// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".getting-to-wizard__icon-separator{\n    background: white;\n    z-index: 1;\n    padding:0.25rem;\n}\n\n.getting-to-wizard__icon-separator.fa-car{\n    margin-left:-2.25rem;\n}\n.getting-to-wizard__icon-separator.fa-walking{\n    margin-left:-2rem;\n    font-size:2.5rem;\n}\n\n.getting-to-wizard__icon-separator + .wizard-step__square-icon{\n    display:none;\n}\n", ""]);
// Exports
module.exports = exports;
